
export default {
    "company_header": "Dettagli azienda",
    "header_product_warning": "Registrarsi al prodotto GrabCAD giusto? Registrati a {0}",
    "label": {
        "first_name": "Nome",
        "last_name": "Cognome",
        "name": "Nome",
        "company_name": "Nome dell'azienda",
        "university_name": "Nome dell'istituto",
        "role": "Ruolo",
        "company_size": "Dimensioni dell'azienda",
        "phone_number": "Numero di telefono",
        "printer": "Possiedi una stampante 3D?",
        "student_printer": "Il tuo istituto possiede una stampante 3D?",
        "uses_printer_for": "Per che cosa viene utilizzata la stampante 3D?",
        "shop_owner": "Sei responsabile della gestione dello shop modelli",
        "shop_users_expected": "Quante persone inviano gli ordini al tuo shop?",
        "email": "Email",
        "email_confirm": "Conferma email",
        "email_again": "Inserisci di nuovo l'indirizzo email",
        "password": "Password",
        "country": "Località",
				"state": "Stato/Regione",
        "password_confirm": "Conferma password",
        "password_again": "Inserisci di nuovo la password",
        "password_hint": "Almeno 6 caratteri",
        "interested_in": "Sono più interessato a...",
        "industry_vertical": "Segmento industriale",
        "industry_level": "Livello professionale",
        "business_email": "Email aziendale",
        "business_email_confirm": "Conferma email aziendale",
        "recaptcha": "Conferma di non essere un robot",
        "industry_level_select": "Seleziona livello professionale",
        "company_size_select": "Seleziona dimensioni",
        "industry_vertical_select": "Seleziona segmento industriale"
    },
    "placeholders": {
        "name": "ad esempio John Smith",
        "first": "Primo",
        "last": "Ultimo",
        "email": "Inserisci indirizzo email",
        "email_confirm": "Inserisci di nuovo l'indirizzo email",
        "password": "Inserisci password",
        "company_name": "Inserisci il nome dell'azienda",
        "university_name": "Inserisci il nome dell'istituto",
        "phone_number": "Inserisci il numero di telefono",
        "printer": "Seleziona risposta",
        "country": "Seleziona il paese",
				"state": "Seleziona il tuo stato o la tua regione",
        "business_email": "Inserisci email aziendale",
        "business_email_confirm": "Conferma email aziendale"
    },
    "terms": {
        "buy_now_text": "Facendo clic su \"Avanti\" confermi di avere letto le nostre",
        "workbench_text": "Facendo clic su \"Registrati a Workbench\" confermi di avere letto le nostre",
        "print_text": "Facendo clic su \"Registrati\" confermi di avere letto le nostre",
        "text": "Facendo clic su \"Registrati alla community\" confermi di avere letto le nostre",
        "link": "Condizioni di utilizzo del servizio"
    },
	"software_terms": {
		"link": "Termini e condizioni software"
	},
    "privacy_policy": {
        "and": "e",
        "link": "l'Informativa sulla privacy",
        "text": "e che accetti di essere vincolato a questi termini."
    },
    "actions": {
        "next": "Avanti",
        "workbench_sign_up": "Registrati a Workbench",
        "sign_up_button": "Registrati",
        "shop_sign_up": "Richiedi una prova gratuita di GrabCAD Shop",
        "sign_up": "Registrati alla community",
        "cancel": "Annulla"
    },
    "error": {
        "name_empty": "Aggiungi il tuo nome",
        "email_taken": "Questo indirizzo email è già registrato Accedi o scegli un altro indirizzo email",
        "email_empty": "Aggiungi il tuo indirizzo email",
        "email_nomatch": "Gli indirizzi email devono corrispondere",
        "email_look": "Inserisci un indirizzo email valido",
        "password_nomatch": "Le password devono corrispondere",
        "password_short": "La password è troppo breve. La lunghezza della password deve essere di almeno 6 caratteri.",
        "password_empty": "Inserisci la password",
        "recaptcha": "Fai clic sulla casella di controllo per confermare di non essere un robot",
        "country_blocked": "Spiacenti, non sei autorizzato a registrarti a GrabCAD",
        "blank": "non può essere lasciato vuoto"
    },
    "active": {
        "email": "Inserisci il tuo vero indirizzo email al quale invieremo un link per la conferma."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "No, e non sono intenzionato a farlo",
            "no_but_interesed": "No, ma sono interessato",
            "yes_for_work": "Sì, per lavoro",
            "yes_as_hobby": "Sì, ma solo per hobby",
            "yes_for_other": "Sì, per altri motivi"
        },
        "student": {
            "no_dont_plan": "No, il mio istituto non è interessato a una stampante 3D",
            "no_but_interesed": "No, ma il mio istituto è interessato ad acquistare una stampante 3D",
            "yes_they_do": "Sì",
            "not_sure": "Non sono sicuro"
        }
    },
    "uses_printer_for": {
        "professional": "Uso professionale",
        "education": "Istruzione/ricerca",
        "hobby": "Hobby",
        "dont_use": "Non utilizzo una stampante 3D"
    },
    "level_values": {
        "administrator_principal_superintendent": "Amministratore",
        "biomedical_engineer": "Ingegnere biomedicale",
        "c_level_executive": "Dirigente",
        "clinical_preclinical": "Dottore",
        "dean_department_head": "Responsabile di ufficio",
        "dentist": "Dentista",
        "designer": "Designer",
        "educator": "Docente",
        "engineer": "Tecnico",
        "equipment_manufacturer": "Montatore",
        "lab_owner": "Proprietario di laboratorio",
        "lab_technician": "Tecnico di laboratorio",
        "marketing": "Marketing",
        "medical_education_and_training": "Docente",
        "parent": "Genitore",
        "practicing_physician": "Medico",
        "president_provost": "Presidente",
        "prosthetist_orthotist": "Ortontista",
        "purchasing": "Acquisti",
        "quality": "Controllo di Qualità",
        "rd_engineering": "R&D",
        "sales": "Vendite",
        "senior_management_administration": "Amministratore",
        "student": "Studente",
        "training": "Formatore",
        "other": "Altro",
        "not_employed": "Disoccupato"
    },
    "industry_values": {
        "aerospace": "Aerospaziale",
        "architecture": "Architettura",
        "arts_entertainment": "Arte e intrattenimento",
        "automotive": "Automotive",
        "commercial_products": "Prodotti commerciali",
        "consumer_electronics": "Elettronica di consumo",
        "consumer_goods": "Beni di consumo",
        "dental": "Odontoiatria",
        "education": "Istruzione",
        "engineering_consulting_service": "Servizi di consulenza ingegneristica",
        "government_military": "Governo/Forze armate",
        "industrial_equipment": "Apparecchiature industriali",
        "jewelry": "Gioielli",
        "medical_device": "Dispositivi medici",
        "service_bureau": "Servizi",
        "toys": "Giocattoli",
        "reseller": "Rivenditore",
        "other": "Altro"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "Non sono un'azienda"
    },
    "yes_no_values": {
        "yes": "Sì",
        "no": "No"
    }
}
